const OfficeMap = () => {
  const handleMapClick = () => {
    window.open(`https://www.google.com/maps/dir/?api=1&destination=51.3362752,-2.9548917`, '_blank');
  };

  return (
    <div className="space-y-4">
      <div className="text-center space-y-2">
        <h2 className="text-2xl font-semibold">Our Office</h2>
        <p className="text-sm text-primary font-medium">
          Serving clients across the UK from our Somerset base
        </p>
      </div>
      
      <div 
        className="rounded-lg overflow-hidden shadow-lg border border-border cursor-pointer hover:shadow-xl transition-shadow"
        onClick={handleMapClick}
      >
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2494.2!2d-2.9548917!3d51.3362752!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4871f9001eef59b1%3A0xa0e2c4665b14f716!2s4FOX%20Security!5e0!3m2!1sen!2suk!4v1234567890"
          width="100%"
          height="450"
          style={{ border: 0 }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="4FOX Security Office Location"
        />
      </div>
      <p className="text-sm text-center text-muted-foreground">
        📍 Click map for directions to our office
      </p>
    </div>
  );
};

export default OfficeMap;
